import {
  AppleBundle,
  PayRequestPayload,
} from "checkout-query-client/api/types";
import { buildApplePostalPayload } from "checkout-query-client/utils/build-payloads/build-base-payload";
import {
  getAcceptedMandates,
  getDeviceFingerprintSessionId,
} from "checkout-query-client/utils/helpers";

import {
  ApplePayEncryptedPaymentBundle,
  ApplePayPaymentHeader,
  EncryptedWallet,
  EncryptedWalletPaymentBundle,
  PayRequest,
  PaymentMethod,
  PaymentMethod_Type,
} from "frontend-client";

export const buildApplePayload = async (
  payload: PayRequestPayload
): Promise<PayRequest> => {
  const { appleBundle, formFields, orderDigest } = payload;
  const request = buildApplePayRequest(appleBundle);

  request.acceptedMandates = getAcceptedMandates(formFields);
  request.orderDigest = orderDigest ?? "";
  request.deviceFingerprintSessionId = getDeviceFingerprintSessionId();

  return await Promise.resolve(request);
};

export const buildApplePayRequest = (appleBundle?: AppleBundle) => {
  {
    const request = new PayRequest();
    const wallet = new EncryptedWallet();
    const paymentMethod = new PaymentMethod();
    const applePayEncryptedPaymentBundle = new ApplePayEncryptedPaymentBundle();
    const header = new ApplePayPaymentHeader();

    if (appleBundle) {
      header.publicKeyHash = appleBundle.paymentData.header.publicKeyHash;
      header.ephemeralPublicKey =
        appleBundle.paymentData.header.ephemeralPublicKey;
      header.transactionId = appleBundle.paymentData.header.transactionId;
      header.applicationData = appleBundle.paymentData.header.applicationData;

      applePayEncryptedPaymentBundle.displayName =
        appleBundle.paymentMethod.displayName.toUpperCase();
      applePayEncryptedPaymentBundle.header = header;
      applePayEncryptedPaymentBundle.data = appleBundle.paymentData.data;
      applePayEncryptedPaymentBundle.signature =
        appleBundle.paymentData.signature;
      applePayEncryptedPaymentBundle.version = appleBundle.paymentData.version;

      const encryptedWalletPaymentBundle = new EncryptedWalletPaymentBundle({
        encryptedPaymentBundle: {
          case: "applePayEncryptedPaymentBundle",
          value: applePayEncryptedPaymentBundle,
        },
      });

      wallet.encryptedWalletPaymentBundle = encryptedWalletPaymentBundle;

      const postalAddress = buildApplePostalPayload(appleBundle.billingContact);
      wallet.billingAddress = postalAddress;
    }

    paymentMethod.wallet = wallet;
    paymentMethod.type = PaymentMethod_Type.WALLET;

    request.paymentMethod = paymentMethod;
    return request;
  }
};
